// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles_nav__Heoh6","waveWrap":"styles_waveWrap__O1xmP","path":"styles_path__rdmYh"};